/**
 * OrbDocCoreConceptsStandardLibrarySLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsStandardLibrarySLDocScreen
 */

import { useOrbDocCoreConceptsStandardLibrarySLDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibrarySLDocScreenLogic';
import type { OrbDocCoreConceptsStandardLibrarySLDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibrarySLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsStandardLibrarySLDocView as OrbDocCoreConceptsStandardLibrarySLDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsStandardLibrarySLDocBodyView } from '@/components/traits/OrbDocCoreConceptsStandardLibrarySLDocBodyView';
import { OrbDocCoreConceptsStandardLibrarySLDocFooterView } from '@/components/traits/OrbDocCoreConceptsStandardLibrarySLDocFooterView';
import { OrbDocCoreConceptsStandardLibrarySLDocHeaderView } from '@/components/traits/OrbDocCoreConceptsStandardLibrarySLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsStandardLibrarySLDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsStandardLibrarySLDocScreenConfig>;
}

export function OrbDocCoreConceptsStandardLibrarySLDocScreenView({ config: propsConfig }: OrbDocCoreConceptsStandardLibrarySLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsStandardLibrarySLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsStandardLibrarySLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsStandardLibrarySL" trait="OrbDocCoreConceptsStandardLibrarySLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsStandardLibrarySLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsStandardLibrarySLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibrarySLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibrarySLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsStandardLibrarySLDocScreenView;
